import { useTranslation } from "react-i18next";
import { LabelsDefaultButtonsProps } from "../../types/labelsDefaultButtonsProps";
import BottomButtonTemplate from "../common/BottomButtonTemplate";

export default function LabelsDefaultBottomButtons(props: LabelsDefaultButtonsProps) {
    const { t } = useTranslation();
    return (
        <div id="div-bottom-buttons" className="row float-right btn-group margin-right-0" role="group" aria-label="Bottom action buttons">
            <BottomButtonTemplate
                text={t("main.printScreen")}
                enabled={props.options.labellingOnline}
                func={props.options.labellingOnlineFunc}
            />
            <BottomButtonTemplate
                text={t("main.offlinePrint")}
                enabled={props.options.labellingOffline}
                func={props.options.labellingOfflineFunc}
            />
            <BottomButtonTemplate
                text={t("main.rxg_Work_Order_Enquiry")}
                enabled={props.options.workorderEnquiry}
                func={props.options.workorderEnquiryFunc}
            />
            <BottomButtonTemplate
                text={t("main.scheduleWorkOrder")}
                enabled={props.options.jobSchedule}
                func={props.options.jobScheduleFunc}
            />
            <BottomButtonTemplate text={t("main.assign")} enabled={props.options.jobAssign} func={props.options.jobAssignFunc} />

            <BottomButtonTemplate text={t("main.changeCloseJob")} enabled={props.options.jobClose} func={props.options.jobCloseFunc} />
        </div>
    );
}
